module.exports = __webpack_public_path__ + "img/ic-menu-active.5c02385b.svg";